<toaster-container [toasterconfig]="toasterConfig" aria-live="polite"></toaster-container> <router-outlet></router-outlet> 